/* ==========================================================================
   ATELIER VITA — Global Client-Side Controller
   Handles Drawer Cart, Variant Switching, and Interactive Hotspots
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  // Cart Drawer Toggle
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');

  function toggleCart(open) {
    if (!cartDrawer) return;
    if (open) {
      cartDrawer.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    } else {
      cartDrawer.classList.add('hidden');
      document.body.style.overflow = '';
    }
  }

  cartTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleCart(true);
    });
  });

  if (cartClose) cartClose.addEventListener('click', () => toggleCart(false));
  if (cartOverlay) cartOverlay.addEventListener('click', () => toggleCart(false));

  // Hotspot Room Curation Modals
  const hotspots = document.querySelectorAll('[data-hotspot]');
  hotspots.forEach(spot => {
    spot.addEventListener('click', () => {
      const targetId = spot.getAttribute('data-target-product');
      const card = document.getElementById(targetId);
      if (card) {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.classList.add('ring-2', 'ring-accent');
        setTimeout(() => card.classList.remove('ring-2', 'ring-accent'), 2000);
      }
    });
  });
});
